/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import React, { Dispatch, SetStateAction } from 'react'

import { truncateString } from '@common/functions'
import WalletProvider from '@components/WalletProvider'
import { WalletWithCreditCard } from '@components/WalletProvider/WalletWithCreditCard'
import useMain from '@hooks/useMain'
import useNetworkWallet from '@hooks/useNetworkWallet'

import { ButtonGroup, ConnectButton, FormsContainer, InputEmail, Tab } from './styles'

const MAX_TRUNCATED_ADDRESS_LENGTH = 16

interface ITabsPayments {
    types: string[]
    active: string
    setActive: Dispatch<SetStateAction<string>>
}

export const TabsPayments: React.FC<ITabsPayments> = ({ types, active, setActive }) => {
    const {
        state: {
            mainInit: { paymentMethods },
        },
        operations: { setCurrentStep },
    } = useMain()

    const {
        operations: { setCurrentWalletAddress, setTruncatedAddress },
    } = useNetworkWallet()

    const [value, setValue] = React.useState('')

    const handleConnect = () => {
        setCurrentWalletAddress(value)
        setTruncatedAddress(truncateString(value, MAX_TRUNCATED_ADDRESS_LENGTH))
        setCurrentStep('inventory-useWinter')
    }

    return (
        <>
            <ButtonGroup>
                {types.length > 1 &&
                    types.map(type => (
                        <Tab key={type} active={active === type} onClick={() => setActive(type)}>
                            {type}
                        </Tab>
                    ))}
            </ButtonGroup>
            <>
                {(active === 'Wallet' || active === 'Crypto') &&
                    paymentMethods.map(
                        paymentMethod =>
                            paymentMethod.type === 'crypto' && (
                                <WalletProvider
                                    key={`payment-method-${paymentMethod.name}`}
                                    paymentMethod={paymentMethod.name}
                                />
                            ),
                    )}

                {active === 'Email' && (
                    <FormsContainer>
                        <InputEmail placeholder="Email" onChange={value => setValue(value.target.value)} />
                        <ConnectButton onClick={handleConnect}>Connect</ConnectButton>
                    </FormsContainer>
                )}

                {active === 'Credit card' &&
                    paymentMethods.map(
                        paymentMethod =>
                            paymentMethod.type === 'creditcard' && (
                                <WalletWithCreditCard
                                    key={`payment-method-${paymentMethod.name}`}
                                    paymentMethod={paymentMethod.name}
                                />
                            ),
                    )}
            </>
        </>
    )
}
